import React, { useState, useEffect, useCallback } from 'react';
import iconSearch from '../../../../assets/icons/ic_search.svg';
import iconRemove from '../../../../assets/icons/ic_remove.svg';
import { useDictionary } from '../../../../utilities/hooks/UseDictionary';
import PropTypes from 'prop-types';
import { searchByBookingRef } from './networking';
import debounce from 'lodash.debounce';

const SearchInputByBookingRef = ({ onValueChanged,setBookingDetails }) => {
    const dictionary = useDictionary();
    const [searchValue, setSearchValue] = useState('');
    const [removeClass, setRemoveClass] = useState('btn btn-remove-search-value d-none');
    const [boxInputSearchClass, setBoxInputSearchClass] = useState('booking-input-search');
    const [results, setResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isResEmpty, setIsResEmpty] = useState(false);

    const fetchResults = async (query) => {
        try {
            setIsLoading(true);
            setIsResEmpty(false);
            const response = await searchByBookingRef(query);
            if(response?.data?.data.length === 0) {
                setIsResEmpty(true);
            }
            setResults(response?.data?.data?.map((e)=>{return{id:e.id,displayId:e.display_id}}) ?? []);
        } catch (error) {
            console.error('Error fetching booking results:', error);
            setResults([]);
        } finally {
            setIsLoading(false);
        }
    };

    const debouncedFetchResults = useCallback(debounce(fetchResults, 400), []);

    const handleChange = (event) => {
        const value = event.target.value;
        setSearchValue(value);
        setBookingDetails(null);
        if (value !== '') {
            setRemoveClass('btn btn-remove-search-value d-block');
            if(value.length > 2) {
                debouncedFetchResults(value);
            }
        } else {
            setRemoveClass('btn btn-remove-search-value d-none');
            setResults([]);
        }
    };

    const handleClear = () => {
        setBookingDetails(null);
        setSearchValue('');
        setRemoveClass('btn btn-remove-search-value d-none');
        setResults([]);
    };

    const handSubmit = () => {
        onValueChanged(searchValue);
    };

    const handleFocus = () => {
        setBoxInputSearchClass('booking-input-search selected');
    };

    const handleBlur = () => {
        setBoxInputSearchClass('booking-input-search');
    };

    return (
        <>
            <label htmlFor="search-input-booking-ref" className="search-input-booking-checkin">{dictionary.booking} #</label>
            <div className={boxInputSearchClass}>
                <a href="#" onClick={handSubmit} className="btn btn-icon" aria-label="Button">
                    <img src={iconSearch} alt="Search" />
                </a>
                <input
                    type="text"
                    value={searchValue}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    className="form-control"
                    placeholder={dictionary.Search_by_Booking_Ref}
                />
                <a href="#" onClick={handleClear} className={removeClass} aria-label="Button">
                    <img id="ic-remove-input-search" src={iconRemove} alt="Clear" />
                </a>
            </div>
            {isLoading && <div className="loading-message">Searching...</div>}
            {results.length > 0 && (
                <div className="results-list">
                    {results.map((result, index) => (
                        // <div key={index} className="result-item" onClick={()=>onValueChanged(result.id)}>
                        <div key={index} className="result-item" onClick={()=>{onValueChanged(result.displayId);setSearchValue(result.displayId);}}>
                            {result.displayId}
                        </div>
                    ))}
                </div>
            )}
            {
                results.length === 0 &&
                searchValue!== '' && isResEmpty == true && (
                    <div className="results-list-empty">
                        {dictionary.No_bookings_found}
                    </div>
                )
            }
        </>
    );
};

SearchInputByBookingRef.propTypes = {
    onValueChanged: PropTypes.func,
    setBookingDetails: PropTypes.func,
};

export default SearchInputByBookingRef;